import { IFinancialExpenditureReport, IFinancialReportStructure, TPatch } from '../types';

export const mergeFinancial = (draft: IFinancialExpenditureReport, slice: TPatch<IFinancialExpenditureReport>) => {
  const sliceKey = Object.keys(slice.data)[0] as keyof IFinancialReportStructure;

  draft.data[sliceKey] = { ...draft.data[sliceKey], ...slice.data[sliceKey] };
};
